import { getRelAttribute } from '@/utils/getRelAttribute'
import Link from 'next/link'

type Props = Omit<React.ComponentProps<typeof Link>, 'href'> & {
  children: React.ReactNode
  url?: string
  nofollow?: boolean
  sponsored?: boolean
  className?: string
  rel?: string
}

export const ConditionalLink = ({
  url,
  nofollow,
  sponsored,
  children,
  className,
  ...rest
}: Props) => {
  const relAttribute = getRelAttribute({
    nofollow,
    sponsored,
    rel: rest.rel,
  })

  if (url) {
    return (
      <Link href={url} rel={relAttribute} className={className} {...rest}>
        {children}
      </Link>
    )
  }

  return <div className={className}>{children}</div>
}
